import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { Suspense, lazy } from 'react';
import { Header, Footer, ScrollToTop, Loading } from './components/_imports';

const HomePage = lazy(() => import('./pages/HomePage'));
const EnterprisePage = lazy(() => import('./pages/EnterprisePage'));
const CandidatePage = lazy(() => import('./pages/CandidatePage'));
const CreateResumePage = lazy(() => import('./pages/create_resume_page/CreateResumePage'));
const CandidateTermsPage = lazy(() => import('./pages/terms_and_policy/candidate/CandidateTermsPage'));
const EnterpriseTermsPage = lazy(() => import('./pages/terms_and_policy/enterprise/EnterpriseTermsPage'));
const NotFoundPage = lazy(() => import('./pages/not_found_page/NotFoundPage'));
const BlogPage = lazy(() => import('./pages/blog/page/BlogPage'));
const BlogPost = lazy(() => import('./pages/blog/post/BlogPost'));
const DeleteAccountPage = lazy(() => import('./pages/delete_account_page/DeleteAccountPage'));

function App() {
  return (
    <Router>
      <ScrollToTop />
      <Header />
      <main role="main">
        <Suspense fallback={<Loading />}>
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/empresa" element={<EnterprisePage />} />
            <Route path="/candidato" element={<CandidatePage />} />
            <Route path="/criarcurriculo" element={<CreateResumePage />} />
            <Route path="/termos-e-politica-candidatos" element={<CandidateTermsPage />} />
            <Route path="/termos-e-politica-empresa" element={<EnterpriseTermsPage />} />
            <Route path="/blog" element={<BlogPage />} />
            <Route path="/blog/:slug" element={<BlogPost />} />
            <Route path="/excluir-conta" element={<DeleteAccountPage />} />
            <Route path="*" element={<NotFoundPage />} />
          </Routes>
        </Suspense>
      </main>
      <Footer />
    </Router>
  );
}

export default App;
